import { Context, createContext } from 'react';
import { IOnePaymentItem, IPlan } from '../model';

export interface IAppShortContext {
  baseCheckoutPath: string;
  yearly: boolean;
  plans?: IPlan[];
  currentSubscriptions: Record<string, number>;
}

export interface IAppContext extends IAppShortContext{
  sport: string;
  totalPrice: number;
  selectedOneTimeItem?: IOnePaymentItem;
  oneTimeItem?: IOnePaymentItem;
  toggleAdditionalPlan: (id: string, state?: boolean) => void;
  showRenewPopup: (data: {plan: IPlan} | null) => void;
  showAll?: (state: boolean) => void;
  isShowAll?: boolean;
}

const defaultValue: IAppContext = {
  sport: window.defaultSport || 'nfl',
  yearly: false,
  currentSubscriptions: {},
  totalPrice: 0,
  baseCheckoutPath: '',
  showRenewPopup: () => {},
  toggleAdditionalPlan: () => {}
}

export const AppShortContext: Context<IAppShortContext> = createContext({
  baseCheckoutPath: '',
  currentSubscriptions: {},
  yearly: true,
} as IAppShortContext);

export const AppContext = createContext<IAppContext | undefined>(undefined);

